var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{ref:"transition",attrs:{"enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut","mode":"out-in","appear":"","duration":"200"}},[(_vm.isActive)?_c('div',{staticClass:"tab",class:_vm.containerClasses},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }